import { render, staticRenderFns } from "./BuildingTree.vue?vue&type=template&id=1ca541bf&"
import script from "./BuildingTree.vue?vue&type=script&lang=js&"
export * from "./BuildingTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports